export const tokenConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
})
